export default __webpack_public_path__ + "static/media/redCat.fee830b4.jpg";